var exports = {
  "k": "x2b2fbebb--fc3d78--container",
};

module.exports = exports;
